import { Injectable } from '@angular/core';

import { StorageService } from '@alfresco/adf-core';

@Injectable({
  providedIn: 'root',
})
export class WkStorageService {
  constructor(private readonly storageService: StorageService) {}

  getItem(key: string): string {
    return this.storageService.getItem(key);
  }

  removeItem(key: string): void {
    return this.storageService.removeItem(key);
  }
}
